import { Megaphone } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const marketingManifest: ModuleDefinition = {
  id: 'marketing',
  name: 'Marketing',
  icon: <Megaphone size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/marketing',
  status: 'active',
  navItems: [
    { label: 'Dashboard', path: '/marketing', icon: '\uD83C\uDFE0' },
    { label: 'Kalender', path: '/marketing/kalender', icon: '\uD83D\uDCC5' },
    { label: 'Bezoeken', path: '/marketing/bezoeken', icon: '\uD83D\uDEB6' },
    { label: 'Attributie', path: '/marketing/attributie', icon: '\uD83C\uDFAF' },
    { label: 'Campagnes', path: '/marketing/campagnes', icon: '\uD83C\uDFAF' },
    { label: 'Budget', path: '/marketing/budget', icon: '\uD83D\uDCB0' },
    { label: 'Metrics', path: '/marketing/metrics', icon: '\uD83D\uDCC8', menu: 'meer' },
    { label: 'Content', path: '/marketing/content', icon: '\uD83D\uDCDD', menu: 'meer' },
    { label: 'Email', path: '/marketing/email', icon: '\u2709\uFE0F', menu: 'meer' },
    { label: 'Segmenten', path: '/marketing/segmenten', icon: '\uD83D\uDC65', menu: 'meer' },
    { label: 'Reviews', path: '/marketing/reviews', icon: '\u2B50', menu: 'meer' },
    { label: 'A/B Tests', path: '/marketing/ab-tests', icon: '\uD83E\uDDEA', menu: 'meer' },
    { label: 'Journeys', path: '/marketing/journeys', icon: '\uD83D\uDDFA\uFE0F', menu: 'meer' },
    { label: 'Referrals', path: '/marketing/referrals', icon: '\uD83E\uDD1D', menu: 'meer' },
    { label: 'Testimonials', path: '/marketing/testimonials', icon: '\uD83D\uDCAC', menu: 'meer' },
    { label: 'Rapportage', path: '/marketing/rapportage', icon: '\uD83D\uDCCA', menu: 'meer' },
    { label: 'Social Media', path: '/marketing/social', icon: '\uD83D\uDCF1', menu: 'meer' },
    { label: 'Planner', path: '/marketing/social/planner', icon: '\uD83D\uDCC5', menu: 'meer' },
    { label: 'Automation', path: '/marketing/automations', icon: '\u26A1', menu: 'meer' },
    { label: 'Budget Beheer', path: '/marketing/budget-beheer', icon: '\uD83D\uDCB8', menu: 'meer' },
    { label: 'Concurrentie', path: '/marketing/concurrentie', icon: '\uD83D\uDD0D', menu: 'meer' },
    { label: 'SEO', path: '/marketing/seo', icon: '\uD83D\uDD0E', menu: 'meer' },
    { label: 'Personas', path: '/marketing/personas', icon: '\uD83E\uDDD1\u200D\uD83D\uDCBC', menu: 'meer' },
    { label: 'Events', path: '/marketing/event-management', icon: '\uD83C\uDF89', menu: 'meer' },
    { label: 'Facebook Leads', path: '/marketing/facebook-leads', icon: '\uD83D\uDCF2', menu: 'meer' },
    { label: 'Meta Advertenties', path: '/marketing/ad-campagnes', icon: '\uD83D\uDCE2', menu: 'meer' },
    { label: 'Content Intelligence', path: '/marketing/content-intelligence', icon: '\uD83E\uDDE0', menu: 'meer' },
    { label: 'Contrarian Hook', path: '/marketing/contrarian-hook', icon: '\u26A1', menu: 'meer' },
  ],

  component: () => import('./index.js'),
};

export default marketingManifest;
